import React from "react";
import prod2 from "../../images/server.svg";
import prod4 from "../../images/IoB.svg";
import CategoryBanner from "../CategoryBanner/CategoryBanner";
// Main component for DevicesMarketplace

const DevicesMarketplace = () => {
  const categoryImage = {
    "SMART-FARMING": prod2,
    "SMART-PROCESSING": prod4,
  };

  return (
    <>
      {/* component to display all category and products */}

      <CategoryBanner
        title="Marketplace for partners to buy and sell"
        MarketCategoryType="89f0d9a4-69f1-4f73-87a6-b1b1c0b62d91"
        categoryImage={categoryImage}
      />
    </>
  );
};

export default DevicesMarketplace;

